import ListTeacherRequest from './list/ListTeacherRequests'

export default function TeacherRequestManagementPage() {
  return <ListTeacherRequest />
}
